const agendaDataList = [
    [{
            date: '11月16日',
            tables: [

                {
                    title: '生命科学奖获奖者学术报告会',
                    subTitle: '（举办地点及具体时间待定）',
                    shortTit: '生命科学奖获奖者学术报告会',
                    table: [{
                        time: '',
                        text: '生命科学奖获奖者学术报告会',
                    }, ],
                },
                {
                    title: '未来科学大奖周暨未来科学艺术展开幕仪式',
                    subTitle: '中国·北京',
                    shortTit: '开幕仪式',
                    table: [{
                        time: '',
                        text: '未来科学大奖周暨未来科学艺术展开幕仪式',
                    }, ],
                },

            ],
        },
        {
            date: '11月17日',
            tables: [{
                title: '物质科学奖获奖者学术报告会',
                shortTit: '物质科学奖获奖者学术报告会',
                subTitle: '（举办地点及具体时间待定）',
                table: [],
            }, ],
        },
        {
            date: '11月18日',
            tables: [{
                title: '数学与计算机科学奖获奖者学术报告会',
                shortTit: '数学与计算机科学奖获奖者学术报告会',
                subTitle: '（举办地点及具体时间待定）',
                table: [],
            }, ],
        },
        {
            date: '11月19日',
            tables: [{
                title: '科学峰会',
                subTitle: '中国·北京',
                shortTit: '科学峰会',
                table: [{
                        arr: [{
                                content: {
                                    class: '<span>致辞</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">骆利群</b>，2021未来科学大奖周Program Committee联席主席，斯坦福大学文理学院讲席教授，美国人文与科学院院士，美国国家科学院院士',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">林海帆</b>，未来科学大奖科学委员会委员，耶鲁大学Eugene Higgins讲席教授，耶鲁大学干细胞中心创始主任，上海科技大学生命学院创始院长（兼），美国科学院院士，美国人文与科学院院士',
                                },
                            },
                            {
                                content: {

                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">邓宏魁</b>，北京大学生命科学学院教授',
                                },
                            },
                        ],
                        dialog: [{
                            hostTitle: '对话主持人:',
                            host: '骆利群',
                            guestTitle: '对话嘉宾:',
                            guest: ['林海帆', '邓宏魁'],
                        }],
                        time: '08:30 - 09:40',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【生命科学】干细胞与再生医学</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>致辞</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">丁洪</b>，未来科学大奖周Steering Committee委员，未来论坛理事，中国科学院物理研究所研究员，北京凝聚态物理研究中心首席科学家</span>',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">叶军</b>，未来科学大奖科学委员会委员，美国科罗拉多大学教授，美国科学院院士，中国科学院外籍院士',
                                },
                            },
                            {

                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">杜江峰</b>，中国科学技术大学教授，中国科学院院士',
                                },
                            },
                            {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">张靖</b>，山西大学教授',
                                },
                            },
                        ],
                        time: '09:45 - 11:05',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【物理】</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>致辞</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">李凯</b>，未来科学大奖科学委员会委员，普林斯顿大学Paul & Marcia Wythes讲席教授，美国工程院院士，中国工程院外籍院士',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">黄如</b>，北京大学教授，中国科学院院士',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">刘明</b>，中科院微电子研究所研究员，中国科学院院士',
                                },
                            },

                        ],
                        dialog: [{
                            hostTitle: '对话主持人:',
                            host: '李凯',
                            guestTitle: '对话嘉宾:',
                            guest: ['黄如', '刘明'],
                        }],
                        time: '11:10 - 12:20',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【计算机】芯片</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>致辞</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">谢晓亮</b>，未来科学大奖周Steering Committee委员，未来论坛理事，北京大学李兆基讲席教授，北京大学北京未来基因诊断高精尖创新中心主任，北京大学BIOPIC中心主任，美国科学院院士，美国医学院院士，中国科学院外籍院士',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">刘河生</b>，哈佛大学附属麻省总医院人脑个体差异实验室主任、南卡罗莱纳医科大学终身教授以及脑影像中心主任、Smart State讲席教授',
                                },
                            },
                            {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">李路明</b>，清华大学航天航空学院教授，神经调控技术国家工程实验室主任，航空宇航系主任，人机与环境工程研究所所长',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">高家红</b>，北京大学讲席教授，北大医学物理和工程北京市重点实验室主任，北大磁共振成像研究中心主任，北大麦戈文脑科学研究所研究员',
                                },
                            },
                        ],
                        time: '14:00 - 15:20',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【生命科学】功能性脑成像与干预</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>致辞</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">田刚</b>，未来科学大奖周Steering Committee委员，未来论坛理事，北京国际数学研究中心主任，中国科学院院士，美国人文与科学院外籍院士',
                                },
                            }, {
                                content: {

                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">阮勇斌</b>，浙江大学数学高等研究院教授',
                                },
                            },
                            {

                                content: {

                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">李骏</b>，复旦大学上海数学中心首席教授',
                                },
                            },
                        ],
                        dialog: [{
                            hostTitle: '对话主持人:',
                            host: '田刚',
                            guestTitle: '对话嘉宾:',
                            guest: ['阮勇斌', '李骏'],
                        }],
                        time: '15:25 - 16:35',
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【数学】代数几何</b>',
                    },
                    {
                        arr: [{
                                content: {
                                    class: '<span>致辞</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">武向平</b>，未来科学大奖周Steering Committee委员，中国科学院国家天文台研究员，中国科学院院士',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">寻找宜居星球</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">周济林</b>，南京大学天文与空间科学学院教授',
                                },
                            },
                            {

                                content: {

                                    class: '<span style="font-weight: 600;">生物再生生命保障系统</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">刘红</b>，北京航空航天大学教授，俄罗斯自然科学院外籍院士，国际宇航科学院院士',
                                },
                            },
                        ],
                        dialog: [{
                            hostTitle: '对话主持人:',
                            host: '武向平',
                            guestTitle: '对话嘉宾:',
                            guest: ['周济林', '刘红'],
                        }],
                        time: "16:40 - 17:50",
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【天文】宜居星球 </h4>',
                    },

                    {
                        arr: [{
                                content: {
                                    class: '<span>致辞</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">骆利群</b>，2021未来科学大奖周Program Committee联席主席，斯坦福大学文理学院讲席教授，美国人文与科学院院士，美国国家科学院院士',
                                },
                            }, {
                                content: {
                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">何川</b>，未来科学大奖科学委员会委员，芝加哥大学讲座教授，美国霍华德·休斯医学研究所研究员',
                                },
                            },
                            {

                                content: {

                                    class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                    personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">付向东</b>，美国UCSD细胞分子医学教授',
                                },
                            },
                        ],
                        time: "20:00 - 21:00",
                        text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【生命科学】RNA生物学，未来医疗新方向 </h4>',
                    },

                ],
            }, ],
        },
        {
            date: '11月20日 ',
            tables: [{
                    title: '科学峰会',
                    subTitle: '中国·北京 ',
                    shortTit: '科学峰会',
                    table: [{
                            arr: [{
                                    content: {
                                        class: '<span>致辞</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">丁洪</b>，未来科学大奖周Steering Committee委员，未来论坛理事，中国科学院物理研究所研究员，北京凝聚态物理研究中心首席科学家</span>',

                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">陈谐</b>，未来科学大奖科学委员会委员，加州理工学院理论物理教授',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">王亚愚</b>，清华大学物理系教授',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">陈仙辉</b>，中国科学技术大学物理系教授，中国科学院院士',
                                    }
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">TBD</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">翁红明</b>，中国科学院物理研究所研究员',
                                    }
                                },

                            ],
                            time: '11:10 - 12:20',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【物理】量子材料</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>致辞</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">励建书</b>，2021未来科学大奖周Program Committee联席主席，浙江大学求是讲席教授，中国科学院院士',
                                    },
                                }, {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">刘一峰</b>，浙江大学数学高等研究院教授',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">恽之玮</b>，麻省理工学院教授',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: '对话主持人:',
                                host: '励建书',
                                guestTitle: '对话嘉宾:',
                                guest: ['刘一峰', '恽之玮'],
                            }],
                            time: '10:00 - 11:10',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【数学】数论</b>',

                        },

                        {
                            arr: [{
                                    content: {
                                        class: '<span>致辞</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">武向平</b>，未来科学大奖周Steering Committee委员，中国科学院国家天文台研究员，中国科学院院士',
                                    },
                                },
                                {
                                    content: {

                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">翁玉林</b>， 未来科学大奖科学委员会委员，美国加州理工学院地质与行星科学系教授，美国人文与科学院院士，台湾中央研究院院士',
                                    },
                                },
                                {
                                    content: {

                                        class: '<span style="font-weight: 600;">月球和深空探测的关键科学问题</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">王赤</b>，中国科学院国家空间科学中心主任，中国科学院院士',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: '对话主持人:',
                                host: '武向平',
                                guestTitle: '对话嘉宾:',
                                guest: ['翁玉林', '王赤'],
                            }],
                            time: '11:15 - 12:25',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【天文】深空探测</b>',
                        },

                        {
                            arr: [{
                                    content: {
                                        class: '<span>主持人</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">郑倩</b>，中国科学院上海天文台研究员',
                                    },
                                }, {
                                    content: {
                                        class: '<span style="font-weight: 600;">宇宙的起源和演化 </span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">武向平</b>，未来科学大奖周Steering Committee委员，中国科学院国家天文台研究员，中国科学院院士',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">超级计算机里的宇宙 </span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">王杰</b>，中国科学院国家天文台研究员',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: '对话主持人:',
                                host: '郑倩',
                                guestTitle: '对话嘉宾:',
                                guest: ['武向平', '王杰'],
                            }],
                            time: '14:00 - 15:10',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【天文】宇宙起源</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>致辞</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">励建书</b>，2021未来科学大奖周Program Committee联席主席，浙江大学求是讲席教授，中国科学院院士',
                                    },
                                }, {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD） </span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">田刚</b>，未来科学大奖周Steering Committee委员，未来论坛理事，北京国际数学研究中心主任，中国科学院院士，美国人文与科学院外籍院士',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD） </span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">刘毅</b>，北京国际数学研究中心研究员',
                                    },
                                },
                            ],
                            dialog: [{
                                hostTitle: '对话主持人:',
                                host: '励建书',
                                guestTitle: '对话嘉宾:',
                                guest: ['田刚', '刘毅'],
                            }],
                            time: '15:15 - 16:25',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【数学】几何拓扑</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>致辞</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">林建华</b>，未来科学大奖周Steering Committee委员，北京大学前校长，北京大学未来教育管理研究中心首创主任',
                                    },
                                }, {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">邓力</b>，未来科学大奖科学委员会委员，西湖大学徐益明讲席教授，西湖大学理学院执行院长',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">高毅勤</b>，北京大学化学与分子工程学院教授',
                                    },
                                },

                            ],
                            dialog: [{
                                hostTitle: '对话主持人:',
                                host: '林建华',
                                guestTitle: '对话嘉宾:',
                                guest: ['邓力', '高毅勤'],
                            }],
                            time: '16:30 - 17:40',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【化学】有机合成分子</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>致辞</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">林建华</b>，未来科学大奖周Steering Committee委员，北京大学前校长，北京大学未来教育管理研究中心首创主任',
                                    },
                                }, {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">崔屹</b>，未来科学大奖科学委员会委员，斯坦福大学材料系终身教授，斯坦福Precourt能源研究所主任，Nano Letters执行主编，美国电池500联盟共同主任',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">主题（TBD）</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">邹晓东</b>，斯德哥尔摩大学教授',
                                    },
                                },

                            ],
                            time: '19:30 - 20:35',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【化学与材料】</b>',
                        },
                        {
                            arr: [{
                                    content: {
                                        class: '<span>致辞</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">李凯</b>，未来科学大奖科学委员会委员，普林斯顿大学Paul & Marcia Wythes讲席教授，美国工程院院士，中国工程院外籍院士',
                                    },
                                }, {
                                    content: {
                                        class: '<span style="font-weight: 600;">个体化新抗原从头测序和癌症免疫治疗</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">李明</b>，未来科学大奖科学委员会委员，滑铁卢大学University Professor，加拿大皇家学会院士',
                                    },
                                },
                                {
                                    content: {
                                        class: '<span style="font-weight: 600;">深度学习预测蛋白质折叠</span>',
                                        personIntro: '<b style="color:rgb(0, 8, 35); font-weight: 600;">许锦波</b>，丰田工业大学芝加哥分校计算技术研究所终身教授',
                                    },
                                },

                            ],
                            time: '20:40 - 21:45',
                            text: '<h4 style=" font-weight: revert; display: inline-block;  font-size: 1rem; ">【计算机】人工智能与生命科学</b>',
                        },


                    ],
                },

                {
                    title: '科学家宴 X 青年科学家创新秀',
                    subTitle: '中国·北京',
                    shortTit: '青年科学家创新秀',
                    table: [{
                        arr: [{
                            time: '',
                            content: {
                                title: '',
                                class: '',
                                personIntro: '',

                            },
                        }, ],
                        time: '18:30 - 20:30',
                        text: '科学家宴 X 青年科学家创新秀（仅限受邀嘉宾）',
                    }, ],
                },
            ],
        },
        {
            date: '11月21日',
            tables: [{
                    title: '获奖者报告&对话青少年',
                    subTitle: '中国·北京 ',
                    shortTit: '获奖者报告&对话青少年',
                    table: [{
                        arr: [{
                                time: '',
                                content: {
                                    title: '',
                                    class: '',
                                    personIntro: '物质科学奖获奖者报告/青少年对话获奖者</span>',
                                },
                            },
                            {
                                time: '',
                                content: {
                                    title: '',
                                    class: '',
                                    personIntro: '数学与计算机科学奖获奖者报告/青少年对话获奖者</span>',
                                },
                            },
                        ],
                        time: '09:00 - 12:00',
                        text: '生命科学奖获奖者报告/青少年对话获奖者 ',
                    }, ]
                },
                {
                    title: '颁奖典礼',
                    subTitle: '中国·北京 ',
                    shortTit: '颁奖典礼',
                    table: [{
                        arr: [{
                            time: '18:30 - 21:00',
                            content: {
                                title: '',
                                class: '',
                                personIntro: '科学公益晚宴（仅限受邀嘉宾）</span>',
                            },
                        }, ],
                        time: '15:30 - 18:00',
                        text: '颁奖典礼',
                    }, ],
                },
            ],
        },
    ],
];
const text = {
    title: '2021未来科学大奖周议程',
    subTitle: '*具体议程以实际到场为准，以下时间为北京时间'
};

const context = {
    title: '2021未来科学大奖周',
    content: `<p style="margin: 0; line-height: 2rem">
2021未来科学大奖周系列活动将于11月16日-21日在北京举办，为期六天。
</p>
<p style="margin: 0; line-height: 2rem">
主要活动包括：<b style="color: #010824"
    >获奖者学术报告会：</b
>由生命科学、物质科学、数学与计算机科学三大奖项获奖人阐述其获奖成果；<b
    style="color: #010824"
    >青少年对话获奖者:</b
>为更多热爱科学的青少年提供一个与科学家面对面交流的机会，激励未来一代走上科学研究和科研创新之路；<b
    style="color: #010824"
    >未来科学大奖颁奖典礼：</b
>表彰为全人类做出重大科研成果的科学家，共同见证获奖人的荣耀时刻；<b
    style="color: #010824"
    >科学峰会：</b
>由世界知名科学家分享前沿科学成果，共同探讨学术创新，共襄科学盛举。
</p>
<p style="margin: 0; line-height: 2rem">
科学改变未来，以科学精神影响大中华区、影响世界、影响下一代。
</p>`
};


const steePersonList = [
    '丛京生',
    '丁洪',
    '林建华',
    '田刚',
    '武向平',
    '谢晓亮',
]

const programPersonList = [
    '励建书（联席主席）',
    '骆利群（联席主席）',
    '陈恂',
    '邓锋',
    '丁健',
    '何川',
    '李凯',
    '李明',
    '林海帆',
    '刘小乐',
    '王晓东',
    '张寿武',
    '张晓东',
]
const live2019 = [{
        title: "2019未来科学大奖",
        etitle: "Future Science Award",
        time: '12/27',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖1",
        etitle: "Future Science Award",
        time: '12/28',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title1",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖2",
        etitle: "Future Science Award",
        time: '12/29',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title2",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖3",
        etitle: "Future Science Award",
        time: '12/30',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title3",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
]
const live2020 = [{
        title: "2020未来科学大奖",
        etitle: "Future Science Award",
        time: '12/27',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖1",
        etitle: "Future Science Award",
        time: '12/28',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title1",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖2",
        etitle: "Future Science Award",
        time: '12/29',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title2",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖3",
        etitle: "Future Science Award",
        time: '12/30',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title3",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
]
const live2021 = [{
        title: "2021未来科学大奖",
        etitle: "Future Science Award",
        time: '12/27',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖1",
        etitle: "Future Science Award",
        time: '12/28',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title1",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖2",
        etitle: "Future Science Award",
        time: '12/29',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title2",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
    {
        title: "未来科学大奖3",
        etitle: "Future Science Award",
        time: '12/30',
        list: [{
            startTime: "09:25",
            endTime: "12:00",
            title: "title3",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, {
            startTime: "09:25",
            endTime: "12:00",
            title: "title",
            playbackUrl: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            pullFlowUrl: "http://jc-qlive-play.jingchangkan.cn/live/3473_187353930_rsx6.m3u8"
        }, ]
    },
]
const zh = {
    agendaDataList,
    text,
    context,
    steePersonList,
    programPersonList,
    live2019,
    live2020,
    live2021,
}




export default zh;